/**
 * Sesotho: Channels
 *
 * What this file covers: Website chat, SMS, email, USSD and the other channels clients reach the business on.
 *
 * Tone: Clear and practical. Say what the client sees on each channel.
 *
 * Sesotho: Everyday Sesotho as used in South African business. Keys not translated yet fall back to English, so
 * a missing key is never an error.
 *
 * Rules for every translation: keep each key exactly as it is and translate only the text after it. Keep
 * {{placeholders}} such as {{count}} or {{name}} unchanged, and keep product names (RepletoryReach, WhatsApp,
 * Meta, Google, Outlook) as they are. Never use the em dash.
 */

import type { Catalog } from '../types';

const channels: Catalog = {
  'channels.title': 'Dikanale',
  'channels.description': 'Dibaka tseo bareki ba ka o ngollang ho tsona, le se hokahantsweng ho e nngwe le e nngwe.',
  'channels.connect': 'Hokahanya leqephe',
  'channels.connected': '{{name}} e hokahantswe.',
  'channels.disconnected': 'E kgaotswe.',
  'channels.check': 'Leka',
  'channels.check.ok': 'Tsohle tseo kanale ena e di hlokang di teng.',
  'channels.check.problems': 'Ho na le ho hong ho hlokang tlhokomelo kanaleng ena.',
  'channels.switchedOff': 'E timilwe',
  'channels.receiving': 'E amohela melaetsa ho tloha ka {{since}}',
  'channels.notReceiving': 'Ha e so amohele melaetsa. Hokahanya leqephe lena hape ho bula phano.',
  'channels.lastCheck.ok': 'E lekilwe la ho qetela ka {{when}}: tsohle di lokile.',
  'channels.lastCheck.failed': 'E lekilwe la ho qetela ka {{when}}: ho na le ho hong ho hlokang tlhokomelo.',
  'channels.disconnect': 'Kgaola',
  'channels.disconnect.title': 'O kgaola kanale ena?',
  'channels.disconnect.body': 'Melaetsa e metjha e yang ho {{name}} e tla emisa ho fihla. Dipuisano tsa hao tse teng di tla dula jwalo ka ha di le teng, mme o ka hokahanya hape neng kapa neng.',
  'channels.disconnect.confirm': 'Kgaola',
  'channels.empty.title': 'Ha ho di-akhaonto tsa Facebook kapa Instagram hajwale',
  'channels.empty.body': 'Hokahanya leqephe la Facebook mme bot ya hao e arabe ho Messenger, le ho Instagram ka akhaonto e hokahantsweng leqepheng leo.',
  'channels.elsewhere.title': 'Dikanale tsa hao tse ding',
  'channels.elsewhere.whatsapp': 'Dinomoro tsa WhatsApp di hokahanngwa ho',
  'channels.elsewhere.website': 'Puisano ya websaete e hlophiswa ho',
  'channels.connect.intro': 'Kena ho Facebook mme o kgethe leqephe leo o batlang bareki ba o ngolle ho lona. Re kopa feela se hlokahalang ho bala leqephe leo le ho araba melaetsa ya lona.',
  'channels.connect.needs': 'O tlameha ho ba molaodi wa leqephe. Bakeng sa Instagram, akhaonto e tlameha ho ba ya botsebi mme e hokahantswe leqepheng leo.',
  'channels.connect.signIn': 'Tswela pele ka Facebook',
  'channels.connectMessenger': 'Hokahanya Messenger',
  'channels.connectInstagram': 'Hokahanya Instagram',
  'channels.alreadyConnected': 'E hokahantswe',
  'channels.instagram': 'Instagram',
  'channels.instagram.ready': 'Akhaonto ya botsebi e hokahantswe leqepheng lena mme e ka hokahanngwa.',
  'channels.instagram.personal': 'Akhaonto ya Instagram leqepheng lena ke ya botho. E fetole hore e be ya botsebi ho app ya Instagram, ebe o kgutla.',
  'channels.instagram.none': 'Ha ho akhaonto ya Instagram e hokahantsweng leqepheng lena hajwale.',
  'channels.cannotMessage': 'O ke ke wa romela melaetsa ho tswa leqepheng lena. Kopa ya le tsamaisang hore a o fe karolo ya melaetsa.',
  'channels.cannotSubscribe': 'O ke ke wa bula phano ya melaetsa bakeng sa leqephe lena. Kopa ya le tsamaisang hore a o etse molaodi.',
  'channels.noPages.title': 'Ha ho maqephe akhaontong ena',
  'channels.noPages.body': 'Akhaonto ena ya Facebook ha e tsamaise maqephe. Kena ka akhaonto e nang le ona.',
  'channels.unavailable.title': 'Ha e so bulwe',
  'channels.unavailable.body': 'Ho hokahanya leqephe la Facebook ha ho so bulwe. Re boleletswe, mme dikanale tsa hao tse ding di tswela pele jwalo ka tlwaelo.',
  'channels.sdk.title': 'Facebook ha e a fihlellwa',
  'channels.sdk.blocked': 'Ho kena ha Facebook ha ho a kgona ho jarolla. Hangata ho bakwa ke sethibedi sa dikahare kapa tlhophiso e thata ya lekunutu; leka hape lemating le tlwaelehileng.',
  'channels.sdk.unavailable': 'Ho kena ha Facebook ha ho a kgona ho jarolla. Hlahloba kgokahano ya hao mme o leke hape.',
  'channels.sdk.noToken': 'Facebook ha e a phetha ho kena. Ha ho letho le hokahantsweng; leka hape.'
};

export default channels;
